import { Link } from 'react-router-dom';
import { useState } from 'react';
import { categories } from '@/mocks/categories';
import { articles } from '@/mocks/articles';
import { testimonials } from '@/mocks/testimonials';
import { faqs } from '@/mocks/faqs';

const services = [
  {
    title: '情感指导',
    description: '专业情感咨询师一对一指导，帮你理清情感困惑，找到爱的方向。',
    icon: 'ri-heart-pulse-line',
  },
  {
    title: '伴侣匹配',
    description: '基于科学算法精准匹配，让你遇见灵魂契合的那个TA。',
    icon: 'ri-user-heart-line',
  },
  {
    title: '感情修复',
    description: '专业修复方案帮你重新点燃爱的火花，挽回珍贵的感情。',
    icon: 'ri-heart-add-line',
  },
  {
    title: '长久陪伴',
    description: '学会经营长期关系，让爱在岁月中愈加醇厚芬芳。',
    icon: 'ri-hand-heart-line',
  },
];

const stats = [
  { value: '50,000+', label: '注册会员' },
  { value: '85%', label: '匹配满意度' },
  { value: '5,000+', label: '成功案例' },
  { value: '8年', label: '专业经验' },
];

export default function Home() {
  const [openFaq, setOpenFaq] = useState<number | null>(null);

  const featuredArticles = articles.filter((a) => a.featured).slice(0, 3);

  return (
    <>
      <HeroSection />
      <StatsSection stats={stats} />
      <CategorySection categories={categories} />
      <FeaturedArticles articles={featuredArticles} />
      <ServiceSection services={services} />
      <TestimonialSection testimonials={testimonials} />
      <FaqSection faqs={faqs} openFaq={openFaq} setOpenFaq={setOpenFaq} />
      <CtaSection />
      <SchemaOrgHome />
    </>
  );
}

function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Soft%20romantic%20abstract%20background%20with%20warm%20coral%20pink%20and%20peach%20gradient%20gentle%20flowing%20organic%20shapes%20like%20petals%20floating%20in%20light%20dreamy%20atmosphere%20clean%20minimal%20editorial%20style%20no%20people%20high%20resolution&width=1600&height=900&seq=hero-bg-main&orientation=landscape"
          alt="久久爱情感陪伴平台"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/40 via-foreground-950/20 to-background-50"></div>
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center pt-20">
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 mb-6 leading-tight">
          让每一段爱
          <br />
          都值得被<span className="text-accent-300">珍惜</span>与<span className="text-accent-300">守护</span>
        </h1>
        <p className="text-base md:text-lg text-background-200 max-w-2xl mx-auto mb-10 leading-relaxed">
          久久爱，专为渴望长久爱情的人打造的情感陪伴平台。无论你正在寻找真爱、维系感情还是修复关系，我们都能为你提供专业情感指导、伴侣匹配与深度陪伴服务。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/categories"
            className="inline-flex items-center px-8 py-3.5 text-base font-medium rounded-full bg-primary-500 text-background-50 hover:bg-primary-600 transition-all duration-200 cursor-pointer whitespace-nowrap"
          >
            探索服务
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
          <a
            href="/about#contact"
            className="inline-flex items-center px-8 py-3.5 text-base font-medium rounded-full border border-background-300/60 text-background-50 hover:bg-background-50/10 transition-all duration-200 cursor-pointer whitespace-nowrap"
          >
            预约咨询
          </a>
        </div>
      </div>
    </section>
  );
}

function StatsSection({ stats }: { stats: { value: string; label: string }[] }) {
  return (
    <section className="relative -mt-16 z-20">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="bg-background-50 rounded-2xl py-8 px-6 grid grid-cols-2 md:grid-cols-4 gap-6">
          {stats.map((stat, i) => (
            <div key={i} className="text-center">
              <div className="text-2xl md:text-3xl font-heading font-bold text-primary-600">
                {stat.value}
              </div>
              <div className="text-sm text-foreground-500 mt-1">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function CategorySection({ categories }: { categories: typeof import('@/mocks/categories').categories }) {
  return (
    <section className="py-16 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            探索我们的服务
          </h2>
          <p className="mt-3 text-foreground-500 max-w-lg mx-auto text-sm">
            五大核心板块，全方位守护你的情感世界
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/categories?tab=${cat.slug}`}
              className="group bg-background-50 border border-background-200/70 rounded-xl p-5 hover:border-primary-300 transition-all duration-300 flex flex-col items-center text-center cursor-pointer"
            >
              <div className="w-14 h-14 rounded-full bg-primary-50 flex items-center justify-center mb-4 group-hover:bg-primary-100 transition-colors">
                <i className={`${cat.icon} text-2xl text-primary-500`}></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-2">{cat.name}</h3>
              <p className="text-xs text-foreground-500 leading-relaxed mb-3">{cat.description}</p>
              <span className="text-xs text-primary-500 font-medium">
                {cat.count} 篇文章
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}

function FeaturedArticles({ articles }: { articles: typeof import('@/mocks/articles').articles }) {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-12">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              精选文章
            </h2>
            <p className="mt-2 text-foreground-500 text-sm">专业情感知识，助你更好地经营爱情</p>
          </div>
          <Link
            to="/categories"
            className="hidden sm:inline-flex items-center text-sm text-primary-500 hover:text-primary-600 font-medium whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line ml-1"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {articles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-300 transition-all duration-300 cursor-pointer flex flex-col"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  title={`${article.title} - 久久爱情感陪伴`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 text-xs font-medium rounded-full bg-primary-500/90 text-background-50">
                    {article.category}
                  </span>
                </div>
              </div>
              <div className="p-5 flex flex-col flex-1">
                <h3 className="text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2 mb-3">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-500 line-clamp-2 mb-4 flex-1">
                  {article.excerpt}
                </p>
                <div className="flex items-center justify-between text-xs text-foreground-400 pt-4 border-t border-background-200/70">
                  <div className="flex items-center gap-2">
                    <img
                      src={article.authorAvatar}
                      alt={article.author}
                      className="w-6 h-6 rounded-full object-cover"
                    />
                    <span>{article.author}</span>
                  </div>
                  <div className="flex items-center gap-3">
                    <span>{article.publishDate}</span>
                    <span>{article.readTime} 分钟阅读</span>
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-8 sm:hidden">
          <Link
            to="/categories"
            className="inline-flex items-center text-sm text-primary-500 font-medium"
          >
            查看全部文章 <i className="ri-arrow-right-line ml-1"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}

function ServiceSection({ services }: { services: { title: string; description: string; icon: string }[] }) {
  return (
    <section className="py-16 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            为什么选择久久爱？
          </h2>
          <p className="mt-3 text-foreground-500 max-w-xl mx-auto text-sm">
            四大核心优势，为您提供全方位的情感陪伴服务
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {services.map((service, i) => (
            <div
              key={i}
              className="group text-center p-6 rounded-xl border border-background-200/70 bg-background-50 hover:border-primary-200 transition-all duration-300"
            >
              <div className="w-16 h-16 mx-auto rounded-full bg-accent-100 flex items-center justify-center mb-5 group-hover:bg-accent-200 transition-colors">
                <i className={`${service.icon} text-2xl text-accent-600`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-900 mb-3">{service.title}</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function TestimonialSection({ testimonials }: { testimonials: typeof import('@/mocks/testimonials').testimonials }) {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            用户心声
          </h2>
          <p className="mt-3 text-foreground-500 max-w-lg mx-auto text-sm">
            听听他们与久久爱的真实故事
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {testimonials.slice(0, 6).map((t) => (
            <div
              key={t.id}
              className="bg-background-50 rounded-xl p-6 border border-background-200/70"
            >
              <div className="flex items-center gap-1 mb-3">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i
                    key={i}
                    className={`text-sm ${i < t.rating ? 'ri-star-fill text-secondary-500' : 'ri-star-fill text-background-300'}`}
                  ></i>
                ))}
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                &ldquo;{t.content}&rdquo;
              </p>
              <div className="flex items-center gap-3 pt-4 border-t border-background-200/70">
                <img
                  src={t.avatar}
                  alt={t.name}
                  className="w-10 h-10 rounded-full object-cover"
                />
                <div>
                  <div className="text-sm font-medium text-foreground-900">{t.name}</div>
                  <div className="text-xs text-foreground-500">
                    {t.city} &middot; {t.age}岁
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function FaqSection({
  faqs,
  openFaq,
  setOpenFaq,
}: {
  faqs: typeof import('@/mocks/faqs').faqs;
  openFaq: number | null;
  setOpenFaq: (v: number | null) => void;
}) {
  return (
    <section className="py-16 md:py-20">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            常见问题
          </h2>
          <p className="mt-3 text-foreground-500 text-sm">
            关于久久爱，你想知道的都在这里
          </p>
        </div>

        <div className="flex flex-col gap-3">
          {faqs.map((faq) => (
            <div
              key={faq.id}
              className="border border-background-200/70 rounded-xl overflow-hidden"
            >
              <button
                className="w-full flex items-center justify-between px-5 py-4 text-left bg-background-50 hover:bg-background-100 transition-colors cursor-pointer"
                onClick={() => setOpenFaq(openFaq === faq.id ? null : faq.id)}
              >
                <span className="text-sm font-medium text-foreground-900 pr-4">
                  {faq.question}
                </span>
                <i
                  className={`text-lg text-foreground-400 transition-transform duration-300 flex-shrink-0 ${
                    openFaq === faq.id ? 'ri-subtract-line' : 'ri-add-line'
                  }`}
                ></i>
              </button>
              {openFaq === faq.id && (
                <div className="px-5 pb-4">
                  <p className="text-sm text-foreground-600 leading-relaxed">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function CtaSection() {
  return (
    <section className="py-16 md:py-20">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="relative rounded-2xl overflow-hidden py-16 px-6 md:px-12 text-center">
          <div className="absolute inset-0">
            <img
              src="https://readdy.ai/api/search-image?query=Dreamy%20abstract%20gradient%20with%20soft%20coral%20pink%20and%20warm%20peach%20colors%20flowing%20organic%20waves%20gentle%20glowing%20atmosphere%20minimal%20elegant%20editorial%20style%20no%20people%20high%20resolution&width=1200&height=500&seq=cta-bg-home&orientation=landscape"
              alt=""
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-primary-600/80"></div>
          </div>
          <div className="relative z-10">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-background-50 mb-4">
              准备好开启你的情感旅程了吗？
            </h2>
            <p className="text-background-200 mb-8 max-w-lg mx-auto text-sm">
              现在就加入久久爱，让我们陪伴你找到真爱、维系感情、守护幸福。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <Link
                to="/categories"
                className="inline-flex items-center px-8 py-3.5 text-base font-medium rounded-full bg-background-50 text-primary-600 hover:bg-background-100 transition-all duration-200 cursor-pointer whitespace-nowrap"
              >
                立即探索
              </Link>
              <a
                href="/about#contact"
                className="inline-flex items-center px-8 py-3.5 text-base font-medium rounded-full border border-background-300/60 text-background-50 hover:bg-background-50/10 transition-all duration-200 cursor-pointer whitespace-nowrap"
              >
                联系咨询师
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function SchemaOrgHome() {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'Organization',
        '@id': 'https://shaoshangliang.cn/#organization',
        name: '久久爱',
        url: 'https://shaoshangliang.cn/',
        description: '久久爱是专为渴望长久爱情的人打造的情感陪伴平台，提供专业情感指导、伴侣匹配与深度陪伴服务。',
        sameAs: [],
      },
      {
        '@type': 'WebSite',
        '@id': 'https://shaoshangliang.cn/#website',
        url: 'https://shaoshangliang.cn/',
        name: '久久爱 - 让爱长久的情感陪伴平台',
        publisher: { '@id': 'https://shaoshangliang.cn/#organization' },
      },
      {
        '@type': 'WebPage',
        '@id': 'https://shaoshangliang.cn/#webpage',
        url: 'https://shaoshangliang.cn/',
        name: '久久爱首页',
        isPartOf: { '@id': 'https://shaoshangliang.cn/#website' },
      },
      {
        '@type': 'FAQPage',
        mainEntity: faqs.map((faq) => ({
          '@type': 'Question',
          name: faq.question,
          acceptedAnswer: {
            '@type': 'Answer',
            text: faq.answer,
          },
        })),
      },
    ],
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
    />
  );
}